<template>
  <div>
    <div style="clear: both; border: 1px solid #cccccc;padding: 20px;margin-top: 20px;margin-bottom: 20px" v-for="(item,index) in value" :key="index">
      <a-col>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="'联系人'+(index+1)">
          <a-input placeholder="请输入联系人" v-model="item.contacts" />
        </a-form-model-item>
      </a-col>
      <a-col>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="'联系电话'+(index+1)">
          <a-input placeholder="请输入联系电话" v-model="item.phoneNum" />
        </a-form-model-item>
      </a-col>
      <a-col>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="'省市区'+(index+1)">
          <shengshixian v-model="item.regionCode"></shengshixian>
        </a-form-model-item>
      </a-col>
      <a-col>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="'详细地址'+(index+1)">
          <a-input placeholder="请输入地址" v-model="item.address" />
        </a-form-model-item>
      </a-col>
      <a-col  style="text-align: right;overflow: hidden">
        <a-button style="text-align: right" type="danger" @click="delone(index)" v-if="index != 0">删除</a-button>
        <a-button style="text-align: right;margin-left:10px" type="primary" @click="pushOne" v-if="index+1 == value.length">添加</a-button>
      </a-col>
    </div>
  </div>
</template>
<script >
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { mixinDevice } from '@/utils/mixin'
import Shengshixian from '@comp/shengshixian.vue'

export default {
  name: "addresslist",
  components: { Shengshixian },
  mixins: [JeecgListMixin, mixinDevice],
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
     template:{
       contacts :'',
       phoneNum :'',
       address :'',
       regionCode :''
     }
    }
  },
  props: {
    value:Array
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) { }
      }
    }
  },
  async created(){
    if(!this.value || this.value.length==0){
      this.value.push(JSON.parse(JSON.stringify(this.template)))
    }
  },
  methods:{
    chooseOk(){
      this.$emit('input',this.value)
      this.$emit('change', this.value)
    },
    save(){
      if(this.value && this.value.length>0){
        this.value.forEach((x,i)=>{
          let flag = true
          for (const k in x) {
            if(x[k]){
              flag = false
            }
          }
          if(flag){
            this.value.splice(i,1)
          }
        })
      }
    },
    delone(k){
      this.value.splice(k,1);
    },
    pushOne(){
      this.value.push(JSON.parse(JSON.stringify(this.template)))
    }
  }
}
</script>

<style scoped>

</style>